.frame,
.button,
.iconButton,
.input {
  min-height: var(--control-height-sm);
  border: 2px solid var(--color-border-control);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-fg);
  font-size: var(--text-sm);
  transition:
    border-color var(--duration-fast) ease,
    color var(--duration-fast) ease,
    background-color var(--duration-fast) ease;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-inline: var(--space-3);
  cursor: pointer;
  white-space: nowrap;
}

.iconButton {
  display: inline-grid;
  width: var(--control-height-sm);
  place-items: center;
  padding: 0;
  cursor: pointer;
}

.input {
  min-width: 0;
  padding-inline: var(--space-2-5);
  outline: none;
}

.frame:hover,
.frame:focus-within,
.button:hover,
.iconButton:hover,
.input:hover {
  border-color: var(--color-accent);
}

.button:hover,
.iconButton:hover {
  color: var(--color-accent);
}

.frame:focus-within,
.button:focus-visible,
.iconButton:focus-visible,
.input:focus-visible {
  border-color: var(--color-accent);
  outline: 2px solid color-mix(in oklab, var(--color-focus) 52%, transparent);
  outline-offset: 2px;
}

.input::placeholder {
  color: var(--color-muted);
}

.iconButton svg {
  width: var(--icon-sm);
  height: var(--icon-sm);
}

.iconAction {
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.iconAction:focus-visible {
  outline: 2px solid var(--color-focus);
  outline-offset: var(--icon-action-outline-offset, 1px);
}

.sectionLabel {
  color: var(--color-muted);
  font-family: var(--font-data);
  font-size: var(--text-xs);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
